import { CommentType } from '@vendasta/task-manager';
import { ExtendedCommentInterface, ExtendedConversationInterface } from './interfaces';
import { SortDirection } from '@vendasta/task';
import { SortInterface } from '@vendasta/task-manager';

export class ProjectTrackerUtils {
  static mapInternalConversationToInbox(conversation: ExtendedConversationInterface): ExtendedCommentInterface {
    return {
      senderName: conversation.sendFrom,
      messageText: conversation.message,
      messageCreated: conversation.created,
      externalMessageId: conversation.source,
      commentType: conversation.isPublic ? CommentType.COMMENT_TYPE_PUBLIC : CommentType.COMMENT_TYPE_PRIVATE,
      taskTitle: conversation.taskTitle,
      senderImageUrl: conversation.senderImageUrl,
    } as ExtendedCommentInterface;
  }
}

export function validateSorts(sorts: SortInterface[]): SortInterface[] {
  const final: SortInterface[] = [];
  sorts.forEach((sort) => {
    if (sort.direction in SortDirection && !!sort.field) {
      final.push(sort);
    }
  });
  return final;
}
